<template>
  <div>
    <Sidebar></Sidebar>
    <Header></Header>
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="mt-4">
            <a href="#/usuario">< Voltar</a>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" xs="12" class="mt-3">
          <label for="nome">Nome:</label>
          <b-form-input v-model="user.name" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" xs="12" class="mt-3">
          <label for="nome">Email:</label>
          <b-form-input v-model="user.email" disabled></b-form-input>
        </b-col>
        <b-col md="4" xs="12" class="mt-3">
          <label for="nome">Telefone:</label>
          <b-form-input v-model="user.mobileNumber" disabled></b-form-input>
        </b-col>
        <b-col md="4" xs="12" class="mt-3">
          <label for="nome">Data de Cadastro:</label>
          <b-form-input v-model="user.registrationDate" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" xs="12" class="mt-3">
          <label for="nome">Profissão:</label>
          <b-form-input v-model="user.jobTitle" disabled></b-form-input>
        </b-col>
        <b-col md="4" xs="12" class="mt-3">
          <label for="nome">Especialidade:</label>
          <b-form-input v-model="user.specialty" disabled></b-form-input>
        </b-col>
        <b-col md="4" xs="12" class="mt-3">
          <label for="nome">Função (no Pedline):</label>
          <b-form-input v-model="user.permissionLevel" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2" xs="12" class="mt-3">
          <label for="nome">CEP:</label>
          <b-form-input v-model="user.zipcode" disabled></b-form-input>
        </b-col>
        <b-col md="2" xs="12" class="mt-3">
          <label for="nome">Estado:</label>
          <b-form-input v-model="user.uf" disabled></b-form-input>
        </b-col>
        <b-col md="4" xs="12" class="mt-3">
          <label for="nome">Cidade:</label>
          <b-form-input v-model="user.city" disabled></b-form-input>
        </b-col>
        <b-col md="4" xs="12" class="mt-3">
          <label for="nome">Bairro:</label>
          <b-form-input v-model="user.neighborhood" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="5" xs="12" class="mt-3">
          <label for="nome">Endereço:</label>
          <b-form-input v-model="user.address" disabled></b-form-input>
        </b-col>
        <b-col md="2" xs="12" class="mt-3">
          <label for="nome">Número:</label>
          <b-form-input v-model="user.number" disabled></b-form-input>
        </b-col>
        <b-col md="5" xs="12" class="mt-3">
          <label for="nome">Complemento:</label>
          <b-form-input v-model="user.complement" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" xs="12" class="mt-3">
          <label for="nome">Local de Trabalho:</label>
          <b-form-input v-model="user.workPlace" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" xs="12" class="mt-3">
          <label for="nome">Currículo:</label>
          <br />
          <a :href="user.curriculum" target="_blank">{{ user.curriculum }}</a>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" xs="12" class="mt-3">
          <label for="nome">Registro do conselho da categoria:</label>
          <br />
          <a :href="user.jobDocument" target="_blank">{{ user.jobDocument }}</a>
        </b-col>
      </b-row>
      <b-row v-show="user.description">
        <b-col md="12" xs="12" class="mt-3">
          <label for="nome">Descrição:</label>
          <vue-editor
            id="description"
            v-model="user.description"
            disabled
          ></vue-editor>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="mb-4">
          <div v-show="!saving" class="mt-4">
            <b-button
              v-show="this.user.approvalStatus !== 'Aprovado'"
              type="submit"
              variant="success"
              @click="changeStatus('Aprovado')"
            >
              <span>Aprovar</span>
            </b-button>
            <b-button
              v-show="this.user.approvalStatus !== 'Reprovado'"
              type="submit"
              variant="danger"
              @click="changeStatus('Reprovado')"
            >
              <span>Reprovar</span>
            </b-button>
          </div>
          <div v-show="saving" class="loading-spinner mt-4"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import http from "@/http";
import router from "@/router";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import authentication from "../util/authentication";

export default {
  name: "UserCrud",
  data() {
    return {
      user: {},
      saving: false
    };
  },
  components: {
    Sidebar,
    Header,
    Footer
  },
  methods: {
    changeStatus(newStatus) {
      var text = newStatus === "Aprovado" ? "APROVAR" : "REPROVAR";
      if (
        confirm(`Tem certeza que deseja ${text} o usuário ${this.user.name}`)
      ) {
        this.saving = true;
        this.user.approvalStatus = newStatus;

        http
          .put("User", this.user, authentication.getHeaders())
          .then(response => {
            this.$router.push("/usuario");
          });
      }
    }
  },
  created() {
    if (this.$route.params.id !== "novo") {
      http
        .get(`User/${this.$route.params.id}`)
        .then(response => {
          this.user = response.data;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/UserCrud.vue